module.exports = __webpack_public_path__ + "img/pressureOff.86eeee50.png";